import PeopleAlsoAsk from "./PeopleAlsoAsk/PeopleAlsoAsk";
import QuickInfo from "./QuickInfo/QuickInfo";
import "./RightComponent.scss";

export const RightComponent = ({ info }: any) => {
  return (
    <>
      {
        <div className="ui-layout-right">
         <QuickInfo info={info} />

          {/* <PeopleAlsoAsk /> */}
        </div>
      }
    </>
  )
}

export default RightComponent


